const ITEMS = [
  "CHA Custom Clearance",
  "International Freight Forwarding",
  "Import–Export Consultancy",
  "GST & IEC Registration",
  "Trademark Filing",
  "Company Incorporation",
  "MCA Compliances",
  "Duty Drawback Advisory",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-white/10 bg-[#111726] py-5 overflow-hidden"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold uppercase tracking-[0.15em] text-lg sm:text-2xl text-slate-500 px-6">
              {item}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#F59E0B] shadow-[0_0_12px_#F59E0B]" />
          </span>
        ))}
      </div>
    </div>
  );
}
